import React from 'react';
import { formatCurrency } from '../../utils/formatters';

export const CostSavingsCard = ({ costSavings }) => {
  if (!costSavings) return null;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4">Cost Savings & ROI</h3>
      
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div>
          <p className="text-sm text-gray-600">Monthly Savings</p>
          <p className="text-lg font-semibold text-green-600">
            {formatCurrency(costSavings.monthlySavings)}
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Downtime Prevention</p>
          <p className="text-lg font-semibold text-blue-600">
            {formatCurrency(costSavings.downtimePrevention)}
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-600">MTTR Reduction</p>
          <p className="text-lg font-semibold text-purple-600">
            {costSavings.mttrReduction}%
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Early Detection Rate</p>
          <p className="text-lg font-semibold text-orange-600">
            {costSavings.earlyDetection}%
          </p>
        </div>
      </div>
      
      <div className="pt-6 border-t">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-gray-600">Annual Savings</span>
          <span className="text-xl font-bold text-green-600">
            {formatCurrency(costSavings.annualSavings)}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">Monthly ROI</span>
          <span className="text-lg font-semibold text-purple-600">
            {costSavings.monthlyROI}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default CostSavingsCard;
